export default __webpack_public_path__ + "locales/it/ChangeUserTypeDialog.json?hash=041e1ed89116f179e0ca4691f30f914a";